import { useEffect, useState } from 'react';
import { getOrGenerateOfferImage } from '../services/SoTellUsApiService';

export function useOfferImage(contactUid?: string, initialOfferImg?: string) {
  const [offerImg, setOfferImg] = useState(initialOfferImg ?? '');
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    setOfferImg(initialOfferImg ?? '');

    if (initialOfferImg || !contactUid) {
      setIsGenerating(false);
      return;
    }

    const controller = new AbortController();
    setIsGenerating(true);

    getOrGenerateOfferImage(contactUid, controller.signal)
      .then((url) => {
        if (!controller.signal.aborted) setOfferImg(url);
      })
      .catch((error: unknown) => {
        if (!controller.signal.aborted) {
          console.error('Unable to prepare offer image', error);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setIsGenerating(false);
      });

    return () => controller.abort();
  }, [contactUid, initialOfferImg]);

  return { offerImg, isGenerating };
}
